import React from 'react';
import { View, Text, TouchableOpacity, Linking, StyleSheet, ImageStyle } from 'react-native';
import type { IFile } from '@/types/admin/messages';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { LazyImage } from '@/components/common/admin/mobile/LazyImage';
import styles from '@/components/residents/propertyChat/ResidentChatWindow.styles';
import { useRemoteImageAspect } from '@/hooks/common/useRemoteImageAspect';
import { getFileExtension, truncateFileName, isImageFileName } from '@/utils/common/file';

export const FileBubble: React.FC<{ file: IFile; isAdmin: boolean; authUserId?: number }> = ({ file, isAdmin }) => {
  const isImage = file.type?.startsWith('image/') || isImageFileName(file.fileUrl || file.uri);
  const imageUrl = file.fileUrl || file.uri || undefined;
  const aspect = useRemoteImageAspect(imageUrl);

  const handleFilePress = () => {
    if (file.fileUrl || file.uri) {
      Linking.openURL(file.fileUrl || file.uri!);
    }
  };

  if (isImage && (file.fileUrl || file.uri)) {
    return (
      <View style={[styles.imageContainer, { alignSelf: !isAdmin ? 'flex-end' : 'flex-start' }]}>
        <TouchableOpacity onPress={handleFilePress} activeOpacity={0.7}>
          <View style={styles.imageBubble}>
            <LazyImage
              source={{ uri: file.fileUrl || file.uri! }}
              style={StyleSheet.flatten<ImageStyle>([
                styles.imagePreview,
                aspect ? { aspectRatio: 1 / aspect } : { aspectRatio: 1 },
              ])}
              resizeMode="cover"
              placeholder={(
                <View
                  style={StyleSheet.flatten([
                    styles.imagePlaceholder,
                    aspect ? { aspectRatio: 1 / aspect } : { aspectRatio: 1 },
                  ])}
                >
                  <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={24} height={24} color={RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY} />
                  <Text style={styles.imageLabel}>Loading image...</Text>
                </View>
              )}
              errorPlaceholder={(
                <View
                  style={StyleSheet.flatten([
                    styles.imagePlaceholder,
                    aspect ? { aspectRatio: 1 / aspect } : { aspectRatio: 1 },
                  ])}
                >
                  <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={24} height={24} color={RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY} />
                  <Text style={styles.imageLabel}>{truncateFileName(file.label || file.name || 'Image', 20)}</Text>
                </View>
              )}
            />
          </View>
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <TouchableOpacity onPress={handleFilePress}>
      <View style={[styles.fileBubbleContainer, { alignSelf: !isAdmin ? 'flex-end' : 'flex-start' }]}>
        <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={32} height={32} color={RESIDENTS_DESKTOP_COLORS.TEXT_SECONDARY} />
        <View style={styles.fileInfo}>
          <Text style={styles.fileNameText}>{truncateFileName(file.label || file.name || 'Attachment', 20)}</Text>
          <Text style={styles.fileExtensionText}>{getFileExtension(file.name || file.label || '')}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default FileBubble;


